import React, { createContext, useContext, useState, useCallback } from 'react'
import Toast from '../components/Toast'

const ToastContext = createContext()

export function useToast() {
    const context = useContext(ToastContext)
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider')
    }
    return context
}

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([])

    const showToast = useCallback((message, type = 'success', duration = 4000) => {
        const id = Date.now()
        const toast = { id, message, type, duration }

        setToasts(prev => [...prev, toast])

        // Auto remove after duration
        if (duration > 0) {
            setTimeout(() => {
                removeToast(id)
            }, duration)
        }

        return id
    }, [])

    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id))
    }, [])

    const success = useCallback((message, duration = 4000) => {
        return showToast(message, 'success', duration)
    }, [showToast])

    const error = useCallback((message, duration = 5000) => {
        return showToast(message, 'error', duration)
    }, [showToast])

    const warning = useCallback((message, duration = 4000) => {
        return showToast(message, 'warning', duration)
    }, [showToast])

    const value = {
        toasts,
        showToast,
        removeToast,
        success,
        error,
        warning
    }

    return (
        <ToastContext.Provider value={value}>
            {children}
            {/* Toast Container */}
            <div className="fixed top-4 right-4 z-50 space-y-2">
                {toasts.map(toast => (
                    <Toast
                        key={toast.id}
                        type={toast.type}
                        message={toast.message}
                        isVisible={true}
                        onClose={() => removeToast(toast.id)}
                        duration={0} // Duration is handled by the context
                    />
                ))}
            </div>
        </ToastContext.Provider>
    )
}
